import { Component, OnInit, ElementRef, ViewChild, ViewContainerRef, ComponentFactoryResolver, Renderer2, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiError, AuthService, BaseVisualizacao, BaseVisualizacaoService, DataTablesService, MessageService, Task, TaskService, VisualizacaoStorageService } from '../../core';
import { RegiaoCrudHttpService, RegiaoAuthGuardService } from './services';
import { RegiaoFilter, RegiaoFilterCollapseComponent } from './filter';
import { regiaoSituacaoAtiva, RegiaoSituacaoBadgeComponent } from './situacao';
import { RegiaoOptions } from './regiao-options';
import { RegiaoTableOptions } from './regiao-table-options';
import { RegiaoSearch } from './regiao-search';
import { RegiaoIntegracaoErpImportService, RegiaoIntegracaoErpImportModalComponent, RegiaoIntegracaoErpImportHttpService } from './integracoes/erp/import';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sgt-regiao',
    templateUrl: './regiao.component.html',
    styleUrls: ['./regiao.component.less']
})
export class RegiaoComponent implements BaseVisualizacao<RegiaoSearch>, OnInit, OnDestroy {
    entities: RegiaoSearch[];
    dataTable: any;
    idDataTable = '#tableRegioes';

    filter = new RegiaoFilter([regiaoSituacaoAtiva.id]);
    @ViewChild('filterCollapse', {static: true}) filterCollapse: RegiaoFilterCollapseComponent;
    @ViewChild('containerTable', {static: true}) containerTable: ElementRef;
    @ViewChild('badgeSituacaoContainer', {read: ViewContainerRef}) badgeSituacaoContainer: ViewContainerRef;

    // Options
    options: RegiaoOptions;

    // Import ERP
    @ViewChild('integracaoErpImportModal') integracaoErpImportModal: RegiaoIntegracaoErpImportModalComponent;
    /** Subscription da execução da importação das regiões do ERP */
    afterImportErpSub$: Subscription;

    constructor(private activatedRoute: ActivatedRoute,
                private componentFactoryResolver: ComponentFactoryResolver,
                private renderer: Renderer2,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private taskService: TaskService,
                private regiaoAuthGuardService: RegiaoAuthGuardService,
                private regiaoCrudHttpService: RegiaoCrudHttpService,
                private regiaoIntegracaoErpImportService: RegiaoIntegracaoErpImportService,
                private regiaoIntegracaoErpImportHttpService: RegiaoIntegracaoErpImportHttpService) { }


    ngOnInit() {
        // Criando as options
        this.createOptions();
        // Subscrevendo ao evento de finalização da importação das regiões do ERP
        this.afterImportErp();

        // Obtendo os dados armazenados da visualização
        const vs = this.visualizacaoStorageService.get();
        if (vs != null) {
            // Se possuir os dados, então setamos o filtro, a página e a ordenação da tabela com os seus valores armazenados
            vs.filterValues.forEach((value, key) => this.filter[key] = value);
            this.filterCollapse.isFilterDirty = true;

            this.createTable().then(() => {
                this.dataTable.page(vs.currentPage)
                                .order(vs.order)
                                .draw(false);
            });
        } else {
            this.createTable();
        }
    }

    /** Cria as opções disponíveis para serem executadas pelos usuários */
    private createOptions() {
        this.options = new RegiaoOptions();

        // Importar do ERP
        this.options.canImportErp = this.regiaoAuthGuardService.canImportErp();
    }

    /** Após realizar a importação das regiões do ERP */
    private afterImportErp() {
        this.afterImportErpSub$ = this.regiaoIntegracaoErpImportService.afterImport
                                            .subscribe(
                                                () => this.search()
                                            );
    }

    /** Abre o modal para importar as regiões do ERP */
    openIntegracaoErpImportModal() {
        this.integracaoErpImportModal.open();
    }

    search() {
        this.dataTable.ajax.reload();
    }

    private afterSearch() {
        // Setando o filtro, a página e a ordenação atual da tabela nos dados armazenados da visualização
        this.visualizacaoStorageService.set(this.filter, '', this.dataTable.page.info().page, this.dataTable.order());

    }

    private closeFilter() {
        this.filterCollapse.close();
        jQuery(this.containerTable.nativeElement).scrollTop(0);
    }

    clearFilter() {
        this.filterCollapse.clear()
        this.dataTable.search('');
    }

    showTable() { }

    /** Cria a Datatables assíncrona */
    createTable(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.dataTablesService.showTable(this.idDataTable, this.dataTable, {
                order: [[1, 'asc']], // codigo asc
                serverSide: true,
                processing: true,
                columns: [
                    {
                        data: null,
                        className: 'col-options',
                        orderable: false,
                        render: (data, type, row, meta) => {
                            const entity = data as RegiaoSearch;

                            // Edit
                            let template = '';

                            // Opções
                            const tableOptions = new RegiaoTableOptions();
                            // Edit
                            tableOptions.canEdit = this.regiaoAuthGuardService.canEdit();

                            // Importar do ERP
                            tableOptions.canImportOneErp = this.regiaoAuthGuardService.canImportOneErp(entity);

                            if (tableOptions.hasAnyOption()) {
                                template += `
                                    <span class="btn-group dropup table-options">
                                        <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                        </button>
                                        <div class="dropdown-menu">
                                `

                                // Edit
                                if (tableOptions.canEdit) {
                                    template += `
                                        <a class="dropdown-item" id="edit" title="Editar">
                                            <i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar
                                        </a>
                                    `;
                                }

                                // Import One ERP
                                if (tableOptions.canImportOneErp) {
                                    template += `
                                        <div class="dropdown-divider"></div>
                                        <a class="dropdown-item" id="importOneErp" title="Importar do ERP">
                                            <i class="fas fa-download"></i> Importar do ERP
                                        </a>
                                    `;
                                }

                                template += `
                                        </div>
                                    </span>
                                `;
                            }

                            return template;
                        },
                        createdCell: (td, cellData, rowData, row, col) => {
                            const entity = cellData as RegiaoSearch;

                            const dropdown = jQuery(td).find('.btn-group');
                            // Ao abrir o dropdown, adicionamos ele no body para exibi-lo corretamente na table
                            dropdown.on('show.bs.dropdown', function() {
                                jQuery('body').append(dropdown.css({
                                        position: 'absolute',
                                        left: dropdown.offset().left,
                                        top: dropdown.offset().top
                                    }).detach());
                            });
                            // Ai fechar o dropdown, adicionamos ele novamente a coluna das opções na table
                            dropdown.on('hidden.bs.dropdown', function() {
                                jQuery(td).append(dropdown.css({
                                    position: 'relative',
                                    left: 'auto',
                                    top: 'auto'
                                }).detach());
                            });

                            // Vinculando os eventos de click das opções da tabela
                            const myself = this;
                            // Opções fora do dropdown
                            jQuery(td).on('click', 'a', function() {
                                if (this.id === 'edit') {
                                    myself.edit(entity);
                                }
                            });
                            // Opções do dropdown
                            dropdown.on('click', 'a', function() {
                                if (this.id === 'edit') {
                                    myself.edit(entity);
                                } else if (this.id === 'importOneErp') {
                                    myself.importOneErp(entity);
                                }
                            });
                        }
                    },
                    {data: 'codigo', className: 'col-codigo text-right', render: (data, type, row, meta) => data},
                    {data: 'codigoIntegracaoErp', className: 'col-codigo-integracao-erp text-right', render: (data, type, row, meta) => data},
                    {data: 'nome', className: 'col-nome', render: (data, type, row, meta) => data},
                    {
                        data: null,
                        className: 'col-situacao text-center',
                        render: () => '',
                        createdCell: (td: any, cellData: any, entity: RegiaoSearch) => {
                            if (entity) {
                                const factory = this.componentFactoryResolver.resolveComponentFactory(RegiaoSituacaoBadgeComponent);
                                const ref = this.badgeSituacaoContainer.createComponent(factory);
                                ref.instance.situacao = entity.situacao;
                                this.renderer.appendChild(td, ref.location.nativeElement);
                            }
                        }
                    },
                ],
                ajax: (data, callback, settings) => { // Evento Ajax para pesquisar as regiões
                    this.closeFilter();

                    const order = data.order[0];
                    this.filter.filterPsq = data.search.value;
                    this.regiaoCrudHttpService.searchWithFilter(this.filter, data.draw, data.start, data.length, order.column, order.dir)
                        .subscribe(
                            response => {
                                this.entities = response.data;
                                this.afterSearch();
                                callback(response);
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar as regiões', error);
                                this.afterSearch();
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        );
                }
            })
            .then(dataTable => {
                this.dataTable = dataTable;
                setTimeout(() => resolve(), 500);
            });
        });
    }

    /** Executa a importação da região do ERP */
    private importOneErp(entity: RegiaoSearch) {
        if (!entity) {
            return;
        }

        const codigoIntegracaoErp = entity.codigoIntegracaoErp ?? '';
        const task = new Task(`Importando região ${codigoIntegracaoErp}`, `Executando importação da região ${codigoIntegracaoErp} do ERP`);
        this.taskService.add(task, task.description);
        this.regiaoIntegracaoErpImportHttpService.importOne(entity.id)
            .subscribe(
                () => {
                    this.taskService.success(task, `Importação da região ${codigoIntegracaoErp} do sistema ERP realizada com sucesso`);
                    this.search();
                },
                (error: ApiError) => this.taskService.error(task, error.message, error.cause, error)
            );
    }


    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: RegiaoSearch) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: RegiaoSearch) {
        this.messageService.confirm(`Deseja realmente excluir a região: ${entity.nome}?`).then(result => {
            if (result) {
                this.regiaoCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir a região: ${entity.nome}`, error)
                    );
            }
        });
    }

    /** Destroi todos badges das situações  */
    private clearBadgeSituacaoContainer() {
        this.badgeSituacaoContainer?.clear();
    }

    ngOnDestroy() {
        this.afterImportErpSub$?.unsubscribe();
        // Destruindo os badges das situações
        this.clearBadgeSituacaoContainer();
    }
}
